import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faPencil, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { GetTarjetasBancariasByFiltersDtoProps } from "api/DTOs/GetTarjetasBancariasByFiltersDto"
import { ColoredNumber } from "features/Contabilidad/components/ColoredNumber"
import {
  FechaBodyTemplate,
  ImageBodyTemplate,
} from "features/Documentos/templates"
import { TFunction } from "i18next"
import { CURRENT_DATE_FORMAT_WITH_24_HOURS } from "../../components/BankCard/constants"
import { ModalEditarTarjetasProps } from "../../components/ModalEditarTarjeta/ModalEditarTarjeta"
import { DEFAULT_BANK_LOGO_URL } from "../../constants"
import { TIPO_TARJETA } from "./TipoTarjeta"
import { TarjetaBancariaProps } from "./tarjetas.adapter"

export interface TarjetasColumnsProps {
  t: TFunction
  setIdToDelete: React.Dispatch<React.SetStateAction<string | null>>
  setModalEditarTarjeta: React.Dispatch<
    React.SetStateAction<ModalEditarTarjetasProps["data"]>
  >
}
export const TARJETAS_COLUMNS = ({
  t,
  setIdToDelete,
  setModalEditarTarjeta,
}: TarjetasColumnsProps) => [
  {
    header: "",
    key: "Logo",
    style: { width: "3%" },
    className:
      "tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-flex-1 tw-max-w-0 !tw-pl-6",
    sortable: false,
    body: (rowData: TarjetaBancariaProps & { logo?: string }) =>
      ImageBodyTemplate({
        concepto: rowData.service,
        src: rowData?.logo || DEFAULT_BANK_LOGO_URL,
        t,
      }),
  },
  {
    header: `${t("bancos.cardsTable.nombre")}`,
    key: "nombre",
    style: { width: "15%" },
    field: "nombre",
    sortable: true,
    sortField: "nombre",
    className:
      "tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-flex-1 tw-max-w-0",
    body: ({ nombre }: GetTarjetasBancariasByFiltersDtoProps) => nombre ?? "-",
  },
  {
    header: `${t("bancos.cardsTable.entityBank")}`,
    key: "entidadBancaria",
    field: "EntidadBancaria.Nombre",
    className:
      "tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-flex-1 tw-max-w-0",
    sortable: true,
    sortField: "EntidadBancaria.Nombre",
  },
  {
    header: `${t("bancos.cardsTable.cardNumber")}`,
    key: "numero",
    field: "numero",
    className:
      "tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-flex-1 tw-max-w-0",
    sortable: true,
    sortField: "numero",
  },
  {
    header: `${t("bancos.cardsTable.type")}`,
    key: "TipoTarjetaBancaria",
    field: "TipoTarjetaBancaria",
    style: { width: "8%" },
    className:
      "tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-flex-1 tw-max-w-0",
    sortable: true,
    sortField: "TipoTarjetaBancaria",
    body: ({ tipo }: GetTarjetasBancariasByFiltersDtoProps) =>
      tipo ? TIPO_TARJETA[tipo] : "-",
  },
  {
    header: `${t("bancos.cardsTable.description")}`,
    key: "descripcion",
    field: "descripcion",
    sortable: true,
    sortField: "descripcion",
    className:
      "tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-flex-1 tw-max-w-0",
  },
  {
    header: `${t("bancos.cardsTable.balance")}`,
    key: "saldo",
    field: "saldo",
    alignCol: "right",
    className:
      "!tw-text-right tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-flex-1 tw-max-w-0",
    body: ({ saldo }: GetTarjetasBancariasByFiltersDtoProps) =>
      saldo && ColoredNumber(saldo),
  },
  {
    header: `${t("bancos.cardsTable.dateActual")}`,
    key: "fechaUltimaActualizacion",
    field: "fechaUltimaActualizacion",
    className: "text-center",
    alignCol: "center",
    body: ({
      fechaUltimaActualizacion,
    }: GetTarjetasBancariasByFiltersDtoProps) =>
      fechaUltimaActualizacion
        ? FechaBodyTemplate(
            { fecha: fechaUltimaActualizacion },
            "",
            CURRENT_DATE_FORMAT_WITH_24_HOURS
          )
        : "-",
  },
  {
    header: " ",
    key: "actionButton",
    style: { width: "3%" },
    className: "!tw-pr-6",
    body: (
      rowData: GetTarjetasBancariasByFiltersDtoProps & { logo?: string }
    ) => (
      <OptionsMenuStorybook
        id={rowData.id}
        items={[
          {
            icon: faPencil,
            hasRedirect: false,
            title: t("bancos.cardsTable.editModal.title"),
            action: () =>
              setModalEditarTarjeta({
                isOpen: true,
                id: rowData.id,
                logo: {
                  concepto: rowData.service,
                  src: rowData?.logo || DEFAULT_BANK_LOGO_URL,
                },
                numero: rowData.numero,
                nombre: rowData.nombre,
              }),
            className: "tw-text-text",
          },
          {
            icon: faTrashCan,
            hasRedirect: false,
            title: t("bancos.cardsTable.deleteModal.title"),
            action: () => rowData.id && setIdToDelete(rowData.id),
            className: "tw-text-danger",
          },
        ]}
        buttonClassName='tw-z-20'
        position='right'
      />
    ),
  },
]
